import type { FaireProductEntity } from "../../entity_types/product";

export const p_g8h5nfy3b4: FaireProductEntity = {
  token: "p_g8h5nfy3b4",
  type: "product",
  name: "Pigeon Thank You Letter Card",
  brandToken: "b_bhuach9k",
  brandName: "Boss Dotty Paper Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/3d6311639a6752a7cb2fbb4ac7a7344a8ce7017238416800ef03edc59d391898.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/18db84d80a7f137249cb1807dd1706718d002d0a7e9f83e9545f02b63c1bca1e.jpeg",
    "https://cdn.faire.com/fastly/eabd20d51a75d97c319088130c80588e2ef4eb377bf71f34f552cdd5abc63e48.jpeg",
  ],
  priceDollars: 2.75,
  description:
    'Send a thank you note with these charming pigeon mail carriers. \n\nPrinted on 100% recycled paper and paired with a coordinating envelope. Blank inside. Available either packaged in a clear sleeve or unpackaged (no sleeve). Also available as a boxed set of 6 cards. Size A2 (4.25" x 5.5"). \n\nThis blank greeting card features an oversized pattern of illustrated pigeons wearing a variety of hats and carrying thank you letters.',
  tags: [],
  msrpDollars: 5.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:27.511Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
